import { render } from "./FuelConsumptionTable.vue?vue&type=template&id=cea1bfca&scoped=true"
import script from "./FuelConsumptionTable.vue?vue&type=script&lang=js"
export * from "./FuelConsumptionTable.vue?vue&type=script&lang=js"

import "./FuelConsumptionTable.vue?vue&type=style&index=0&id=cea1bfca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea1bfca"]])

export default __exports__